export const design_unit_list = {
    1:'尺寸',
    2:'时长',
}